import { InfoModalType } from './info-modal-type.enum';

export interface InfoModalEvent {
  /** Usually the radio-group name */
  domain: string;
  /** Usually a radio group item name */
  subdomain?: string;
  /** Kind of info requested */
  category: InfoModalType;
}
